export enum ProductFieldSet {
    ProductTile = "PRODUCT_TILE",
    ImageViewer = "IMAGEVIEWER",
    Full = "FULL"
}
